import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  LinearProgress,
  Autocomplete,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { setSuccess } from "../../../../Redux/AlertReducer";
import { useDispatch } from "react-redux";
import { Helper } from "../../../../tools/Helper";
import { api_Routes } from "../../../../tools/api_Routes";

export const FormWhatsappGroup = ({ Panels, loading }) => {
  const [loadingSubmit, setloadingSubmit] = useState(false);
  const [errors, setErrors] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const itemsPerPage = 25;

  // Panels State
  const [panelsPage, setPanelsPage] = useState(1);
  const [panelSearchQuery, setPanelSearchQuery] = useState("");
  const paginatedPanels = Panels.slice(0, panelsPage * itemsPerPage);
  const filteredPanels = Panels.filter((panel) =>
    panel.name.toLowerCase().includes(panelSearchQuery.toLowerCase())
  );
  const displayedPanels = panelSearchQuery ? filteredPanels : paginatedPanels;

  const [formData, setFormData] = useState({
    title: "",
    url: "",
    owner: "",
    owner_panel: "",
    active: 1,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePanelChange = (event, value) => {
    setFormData((prev) => ({ ...prev, owner_panel: value.id || "" }));
  };

  const handleSubmit = async (e) => {
    setloadingSubmit(true);
    e.preventDefault();
    try {
      const { result, response, message } = await Helper.Post({
        url: api_Routes.Groups.Whatsapp.Add,
        data: {
          ...formData,
        },
      });
      setloadingSubmit(false);
      if (response) {
        setErrors("");
        dispatch(setSuccess(true));
        console.log("Form submission successful:", response);
        navigate("/WhatsappGroups");
      } else {
        setErrors(message);
      }
    } catch (error) {
      console.error("An error occurred during form submission:", error);
      setloadingSubmit(false);
    }
  };

  console.log(formData);

  return loading ? (
    <LinearProgress />
  ) : (
    <form onSubmit={handleSubmit}>
      <div className="flex flex-col justify-between items-center gap-x-6 md:flex-row">
        <TextField
          fullWidth
          margin="normal"
          label="Title"
          name="title"
          required
          autoComplete="off"
          value={formData.title}
          onChange={handleInputChange}
          variant="outlined"
        />
        <div className="w-full">
          <Autocomplete
            disablePortal
            loading={loading}
            options={displayedPanels}
            getOptionLabel={(option) => option.name || ""}
            onChange={handlePanelChange}
            onInputChange={(event, value) => setPanelSearchQuery(value)}
            renderInput={(params) => (
              <TextField {...params} label="Panel" variant="outlined" />
            )}
            ListboxProps={{
              onScroll: (event) => {
                const listboxNode = event.currentTarget;
                if (
                  listboxNode.scrollTop + listboxNode.clientHeight >=
                  listboxNode.scrollHeight - 3
                ) {
                  setPanelsPage((prevPage) => prevPage + 1);
                }
              },
            }}
          />
        </div>
      </div>

      <div className="flex flex-col justify-between items-start gap-x-6 md:flex-row">
        <TextField
          fullWidth
          margin="normal"
          label="URL"
          name="url"
          required
          autoComplete="off"
          value={formData.url}
          onChange={handleInputChange}
          variant="outlined"
          error={!!errors}
          helperText={errors}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Owner"
          name="owner"
          required
          autoComplete="off"
          value={formData.owner}
          onChange={handleInputChange}
          variant="outlined"
        />
      </div>

      <div className="w-full flex items-center justify-start gap-x-3">
        <FormLabel sx={{ fontWeight: "bold" }} component="legend">
          active :
        </FormLabel>
        <RadioGroup
          name="active"
          value={formData.active}
          onChange={handleInputChange}
          row
        >
          <FormControlLabel value="1" control={<Radio />} label="Yes" />
          <FormControlLabel value="0" control={<Radio />} label="No" />
        </RadioGroup>
      </div>
      {loadingSubmit ? (
        <Button
          fullWidth
          variant="contained"
          color="primary"
          sx={{
            display: "flex",
            marginTop: 2,
            width: "20%",
            marginX: "auto",
            fontWeight: "bold",
            justifyContent: "center",
          }}
        >
          <CircularProgress size={24} color="inherit" />
        </Button>
      ) : (
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          sx={{
            display: "block",
            marginTop: 2,
            width: "20%",
            marginX: "auto",
            fontWeight: "bold",
          }}
        >
          Submit
        </Button>
      )}
    </form>
  );
};
